import { Sparkles } from "lucide-react";
import { useLanguage } from "@/i18n";

export default function Marquee() {
  const { t } = useLanguage();
  const items = [...t.marquee, ...t.marquee];

  return (
    <div
      data-testid="marquee-section"
      className="relative overflow-hidden border-y border-cyan-400/15 bg-[#070A1C] py-5"
    >
      <div className="marquee-track flex w-max items-center gap-10">
        {items.map((item, i) => (
          <span key={i} className="flex items-center gap-10">
            <span className="font-pixel whitespace-nowrap text-sm tracking-[0.3em] text-slate-400">
              {item}
            </span>
            <Sparkles className="h-4 w-4 shrink-0 text-cyan-400/60" />
          </span>
        ))}
      </div>
    </div>
  );
}
